module.exports = ".numberEdit {\n  width: 80px;\n}\n\n\n#popupMessage {\n  padding: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/panel-share-viewer/panel-share-viewer.component.css
// module id = ./src/app/components/panel-share-viewer/panel-share-viewer.component.css
// module chunks = main